/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import "./index.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Button from '@atlaskit/button';
import AkInlineDialog from '@atlaskit/inline-dialog';
import { buttonActionTypes } from '../../common/types/button';
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import HtmlContent from '../../controllers/utils/html-content';
var baselineUnit = "var(--ds-space-050, 4px)";
var COLOR_N900 = '#091E42';

// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
var ContentContainer = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "div" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4", __cmplp.className])
  }));
});

// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
if (process.env.NODE_ENV !== 'production') {
  ContentContainer.displayName = 'ContentContainer';
}
var Image = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "img" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq", __cmplp.className])
  }));
});

// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
var ButtonContainer = forwardRef(function (_ref3, __cmplr) {
  var _ref3$as = _ref3.as,
    C = _ref3$as === void 0 ? "div" : _ref3$as,
    __cmpls = _ref3.style,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1b66", __cmplp.className])
  }));
});

// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
if (process.env.NODE_ENV !== 'production') {
  ButtonContainer.displayName = 'ButtonContainer';
}
var BodyContainer = forwardRef(function (_ref4, __cmplr) {
  var _ref4$as = _ref4.as,
    C = _ref4$as === void 0 ? "div" : _ref4$as,
    __cmpls = _ref4.style,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ca0q1b66 _n3td1b66 _syazj3m3", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  BodyContainer.displayName = 'BodyContainer';
}
// eslint-disable-next-line @repo/internal/react/no-class-components
var InlineDialog = /*#__PURE__*/function (_Component) {
  function InlineDialog() {
    var _this;
    _classCallCheck(this, InlineDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InlineDialog, [].concat(args));
    _defineProperty(_this, "onPrimaryClick", function () {
      _this.props.fireClickEvent('primary');
    });
    _defineProperty(_this, "onSecondaryClick", function () {
      _this.props.fireClickEvent('secondary');
    });
    return _this;
  }
  _inherits(InlineDialog, _Component);
  return _createClass(InlineDialog, [{
    key: "getPrimaryButton",
    value: function getPrimaryButton() {
      var _this$props = this.props,
        primaryAction = _this$props.primaryAction,
        primaryText = _this$props.primaryText;
      return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
  }, {
    key: "getSecondaryButton",
    value: function getSecondaryButton() {
      var _this$props2 = this.props,
        secondaryAction = _this$props2.secondaryAction,
        secondaryText = _this$props2.secondaryText;
      return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
  }, {
    key: "getActionButton",
    value: function getActionButton(appearance, onClick, action, text) {
      var type = action ? action.type : buttonActionTypes.DISMISS;
      switch (type) {
        case buttonActionTypes.LINK:
          {
            var actionData = action.data;
            return /*#__PURE__*/React.createElement(Button, {
              href: actionData.url,
              target: actionData.target,
              appearance: appearance,
              onClick: onClick
            }, text);
          }
        default:
          return /*#__PURE__*/React.createElement(Button, {
            appearance: appearance,
            onClick: onClick
          }, text);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        title = _this$props3.title,
        imageSrc = _this$props3.imageSrc,
        imageAlt = _this$props3.imageAlt,
        body = _this$props3.body,
        position = _this$props3.position,
        order = _this$props3.order,
        secondaryText = _this$props3.secondaryText;
      var messageContent = {
        image: null,
        title: null,
        body: null
      };
      if (title) {
        // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/React.createElement("h4", {
          key: "title"
        }, title);
      }
      if (imageSrc) {
        messageContent.image = /*#__PURE__*/React.createElement(Image, {
          key: "img",
          src: imageSrc,
          alt: imageAlt
        });
      }
      messageContent.body = /*#__PURE__*/React.createElement(BodyContainer, {
        key: "body"
      }, /*#__PURE__*/React.createElement(HtmlContent, {
        html: body
      }));
      var orderedContent = order.map(function (c) {
        return messageContent[c];
      });
      var content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContentContainer, null, orderedContent), /*#__PURE__*/React.createElement(ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
      return /*#__PURE__*/React.createElement(AkInlineDialog, {
        content: content,
        placement: position,
        isOpen: true
      }, children);
    }
  }]);
}(Component);
_defineProperty(InlineDialog, "defaultProps", {
  children: null,
  order: ['title', 'image', 'body'],
  position: 'bottom left'
});
var InlineDialogWithEvents = withEvents(InlineDialog);
export { InlineDialog, InlineDialogWithEvents };
export default withMessage(InlineDialogWithEvents, 'inlineDialog');